import { render, staticRenderFns } from "./EModalAlunosMatriculados.vue?vue&type=template&id=66f06d05"
import script from "./EModalAlunosMatriculados.vue?vue&type=script&lang=js"
export * from "./EModalAlunosMatriculados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports